<nav
  class="mobile-nav-menu d-flex flex-column d-lg-none"
  role="navigation"
  aria-label="Mobile navigation"
>
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between align-items-center">
    <a class="nav-brand" [routerLink]="['/']" aria-label="Go to homepage">
      <img
        class="home-logo"
        [src]="'logos/phxid-logo.svg' | contentAssetImage"
        draggable="false"
        alt="PHX ID logo"
      />
    </a>

    <div class="right-mobile-nav-container">
      <button
        class="nav-toggler"
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="mobile-nav-dropdown"
        aria-label="Open navigation menu"
      >
        <span class="material-icons" aria-hidden="true">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div
    id="mobile-nav-dropdown"
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-dropdown"
    role="dialog"
    aria-modal="true"
    aria-label="Navigation menu"
  >
    <div class="mobile-nav-content">
      <!-- Header -->
      <div class="nav-header">
        <a [routerLink]="['/']" aria-label="Go to homepage">
          <img
            class="home-logo"
            [src]="'logos/phxid-black-logo.svg' | contentAssetImage"
            draggable="false"
            alt="PHX ID logo"
          />
        </a>
        <button
          class="close-btn"
          (click)="isCollapsed = !isCollapsed"
          aria-label="Close navigation menu"
        >
          <span class="material-icons" aria-hidden="true">close</span>
        </button>
      </div>

      <!-- Nav Links -->
      <ul class="nav-list" role="list">
        <li>
          <a
            class="nav-link"
            [routerLink]="['/account']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true"
              >account_circle</span
            >
            <span class="nav-label">{{ "nav.profile" | translate }}</span>
          </a>
        </li>

        <li>
          <a
            class="nav-link"
            [routerLink]="['/payment']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true"
              >credit_card</span
            >
            <span class="nav-label">{{ "nav.phx.pay" | translate }}</span>
          </a>
        </li>

        <li>
          <a
            class="nav-link"
            [href]="'nav.manage.tickets.url' | translate"
            target="_blank"
          >
            <span class="material-icons nav-icon" aria-hidden="true"
              >confirmation_number</span
            >
            <span class="nav-label">{{
              "nav.manage.tickets" | translate
            }}</span>
          </a>
        </li>

        <li>
          <a
            class="nav-link"
            [href]="'nav.scan.parking.url' | translate"
            target="_blank"
          >
            <span class="material-icons nav-icon" aria-hidden="true"
              >local_parking</span
            >
            <span class="nav-label">{{ "nav.scan.parking" | translate }}</span>
          </a>
        </li>

        <li>
          <a
            class="nav-link"
            [routerLink]="['/rewards/wallet']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="material-icons nav-icon" aria-hidden="true"
              >account_balance_wallet</span
            >
            <span class="nav-label">{{ "nav.rewards" | translate }}</span>
          </a>
        </li>

        <li>
          <button class="nav-link" (click)="openHowItWorks()">
            <span class="material-icons nav-icon" aria-hidden="true">help</span>
            <span class="nav-label">{{ "nav.how.it.works" | translate }}</span>
          </button>
        </li>

        <fgb-how-it-works #howItWorksModal class="d-none"></fgb-how-it-works>

        <!-- Help accordion -->
        <li class="nav-accordion">
          <button
            class="nav-link nav-accordion-toggle"
            (click)="isHelpOpen = !isHelpOpen"
            [attr.aria-expanded]="isHelpOpen"
            aria-controls="help-submenu"
          >
            <span class="material-icons nav-icon" aria-hidden="true">info</span>
            <span class="nav-label">{{ "nav.help" | translate }}</span>
            <span
              class="material-icons accordion-chevron"
              [class.open]="isHelpOpen"
              aria-hidden="true"
              >expand_more</span
            >
          </button>

          <ul
            id="help-submenu"
            class="nav-submenu"
            [ngbCollapse]="!isHelpOpen"
            role="list"
          >
            <li>
              <a
                class="nav-sublink"
                [routerLink]="['/terms']"
                [routerLinkActive]="'active'"
              >
                {{ "nav.terms" | translate }}
              </a>
            </li>
            <li>
              <a class="nav-sublink" [href]="'nav.faqs.url' | translate">
                {{ "nav.faqs" | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ul>

      <!-- Log Out -->
      <div class="nav-footer mb-2">
        <button
          class="logout-btn"
          (click)="logout()"
          aria-label="Log out of your account"
        >
          <span class="material-icons" aria-hidden="true">logout</span>
          <span>{{ "nav.log.out" | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</nav>
